import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const Leistungen = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const leistungen = [
    {
      title: 'Grundpflege',
      description: 'Sie brauchen eine helfende Hand bei den kleinen Dingen des Alltags? Von der Haarwäsche über das Zerkleinern des Essens bis hin zum Verlassen der Wohnung – Wir unterstützen Sie.',
      icon: '🤝',
      color: 'from-turquoise-50 to-turquoise-100',
      borderColor: 'border-turquoise-400',
      link: '/leistungen/grundpflege'
    },
    {
      title: 'Behandlungspflege',
      description: 'Sie leiden an einer Krankheit und brauchen kompetente Unterstützung bei deren Behandlung? Vom Anziehen der Kompressionsstrümpfe, über die Blutdruckmessung bis hin zum Setzen von Insulinspritzen – Wir stehen Ihnen fachkundig zur Seite',
      icon: '⚕️',
      color: 'from-turquoise-50 to-turquoise-100',
      borderColor: 'border-turquoise-400',
      link: '/leistungen/behandlungspflege'
    },
    {
      title: 'Hauswirtschaftliche Versorgung',
      description: 'Sie kommen nicht mehr selbst an jede Ecke heran? Sie schaffen es nicht mehr ohne Schwierigkeit, die Bettdecke frisch zu beziehen? Vom Geschirrspülen über\'s Einkaufen bis zur Müllentsorgung – Wir sorgen dafür, dass Sie sich in Ihren eigenen vier Wänden auch wohlfühlen.',
      icon: '🏠',
      color: 'from-green-50 to-green-100',
      borderColor: 'border-green-600',
      link: '/leistungen/hauswirtschaft'
    },
    {
      title: 'Palliativpflege',
      description: 'Sie brauchen jemanden, der Sie auf dem letzten Stück des Weges begleitet? Egal ob Beratung, Begleitung und Versorgung – Wir sind bis zum Ende für Sie da!',
      icon: '🕊️',
      color: 'from-purple-50 to-purple-100',
      borderColor: 'border-purple-600',
      link: null
    },
    {
      title: 'Urlaubs- und Verhinderungspflege nach § 39 SGB XI',
      description: 'Sie brauchen jemanden, der sich kurzfristig um die Pflege eines Angehörigen kümmert? Egal ob Arzttermin, Krankheit oder Urlaub – Wir vertreten Sie zuverlässig!',
      icon: '✈️',
      color: 'from-orange-50 to-orange-100',
      borderColor: 'border-orange-600',
      link: null
    },
    {
      title: 'Beratungseinsätze nach § 37 SGB XI',
      description: 'Sie werden von einem Angehörigen gepflegt und beziehen Pflegegeld? Je nach Pflegegrad müssen Sie in regelmäßigen Abständen einen Beratungseinsatz nach SGB XI § 37 in Anspruch nehmen – Wir beraten Sie umfassend und professionell!',
      icon: '📋',
      color: 'from-indigo-50 to-indigo-100',
      borderColor: 'border-indigo-600',
      link: '/leistungen/beratung'
    },
    {
      title: 'Betreuungspflege nach SGB XI § 45b',
      description: 'Sie suchen nach einem Begleiter für Ihren täglichen Spaziergang oder einen Partner beim Kartenspiel? Wir übernehmen gerne zusätzliche Betreuungs- sowie Entlastungsleistungen.',
      icon: '🎴',
      color: 'from-pink-50 to-pink-100',
      borderColor: 'border-pink-600',
      link: null
    },
    {
      title: 'Serviceleistungen',
      description: 'Kostenübernahmeberatung, Hilfe bei Antragstellungen (Versorgungsamt / Pflege- und Krankenkassen) sowie Fahr- und Begleitdienste',
      icon: '🚗',
      color: 'from-yellow-50 to-yellow-100',
      borderColor: 'border-yellow-600',
      link: null
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-turquoise-50 to-white">
      <SEO 
        title="Unsere Leistungen"
        description="Umfassende Pflegeleistungen: Grundpflege, Behandlungspflege, hauswirtschaftliche Versorgung, Beratung und mehr. Ambulante Pflege Großstadtherzen® Leipzig & Halle."
        keywords="Grundpflege, Behandlungspflege, Hauswirtschaft, Pflegeleistungen, ambulante Pflege Leipzig"
        canonicalPath="/leistungen"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 px-4 overflow-hidden" data-testid="leistungen-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-turquoise-400 to-turquoise-400 opacity-10"></div>
        <div className="container mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Unsere Leistungen
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professionelle Pflege und Betreuung für jeden Bedarf
          </p>
        </div>
      </section>

      {/* Leistungen Grid */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
            {leistungen.map((leistung, index) => {
              const CardContent = (
                <>
                  <div className="text-5xl mb-4">{leistung.icon}</div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{leistung.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{leistung.description}</p>
                  {leistung.link && (
                    <span className="inline-block mt-4 text-turquoise-600 font-semibold">
                      Mehr erfahren →
                    </span>
                  )}
                </>
              );

              return leistung.link ? (
                <Link
                  key={index}
                  to={leistung.link}
                  className={`bg-gradient-to-br ${leistung.color} rounded-3xl shadow-xl p-8 hover:shadow-2xl transition-all transform hover:-translate-y-1 border-l-4 ${leistung.borderColor} block`}
                  data-testid={`leistung-card-${index}`}
                >
                  {CardContent}
                </Link>
              ) : (
                <div 
                  key={index} 
                  className={`bg-gradient-to-br ${leistung.color} rounded-3xl shadow-xl p-8 hover:shadow-2xl transition-all transform hover:-translate-y-1 border-l-4 ${leistung.borderColor}`}
                  data-testid={`leistung-card-${index}`}
                >
                  {CardContent}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-gradient-to-br from-turquoise-400 to-turquoise-400 text-white">
        <div className="container mx-auto text-center max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Interessiert an unseren Leistungen?
          </h2>
          <p className="text-xl mb-8">
            Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/angebot"
              className="bg-white text-turquoise-400 px-8 py-4 rounded-full text-lg font-semibold hover:bg-turquoise-50 transition-all shadow-lg"
            >
              Angebot anfordern
            </Link>
            <a 
              href="tel:034124927833"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-turquoise-400 transition-all"
            >
              Jetzt anrufen
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Leistungen;